// extracted by mini-css-extract-plugin
export var partners = "styles-module--partners--bSsgL";
export var partners_person = "styles-module--partners_person--24X9A";
export var partners_links = "styles-module--partners_links--24yPn";
export var partners_info = "styles-module--partners_info--MLfvg";